<!-- eslint-disable max-lines -->
<template>
    <Paper class="example" v-loading="apiAwait">
        <div class="departure">
            <div class="content">
                <speed :process="process"></speed>
            </div>
            <div class="base-info">
                <info-show
                    :infoData="infoData"
                    :showLog="true"
                    @operation="operation"
                    @openMapClick="openMapClick"
                ></info-show>
            </div>
            <el-collapse v-model="collapseActive" class="other-info">
                <el-collapse-item title="费用信息" name="1">
                    <info-show
                        :infoData="feeInfoData"
                        :showLog="false"
                    ></info-show>
                </el-collapse-item>
            </el-collapse>
            <detail-table
                :resDispatchStatus="resDispatchStatus"
                @reserveClick="reserveClick"
                :process="process"
                :isShipment="isShipment"
                :tableData="tableDatas"
                :isOperation="isOperation"
                :wtTypeFlag="wtTypeFlag"
                @getHandLoadingsSave="getHandLoadingsSave"
            ></detail-table>
            <el-card class="box-card">
                <div class="box-card-title">
                    <div class="box-card-left">
                        <span>
                            &nbsp;&nbsp;总里程：{{ totalMileage }}Km（
                            装货补贴里程：{{
                                loadSubsidyMileage
                            }}Km&nbsp;&nbsp;/&nbsp;&nbsp; 卸货补贴里程：{{
                                unloadSubsidyMileage
                            }}Km&nbsp;&nbsp;/&nbsp;&nbsp; 串点里程：{{
                                subsidyMileage
                            }}Km ）（ 配送导航里程：{{
                                subsidyMileage + unloadSubsidyMileage
                            }}Km &nbsp;&nbsp;/&nbsp;&nbsp; 提货补贴里程：{{
                                loadSubsidyMileage
                            }}Km ）
                        </span>
                    </div>
                    <div class="box-card-right">
                        <el-button
                            v-if="isHandleTableLists"
                            type="primary"
                            @click="handleTableLists"
                            v-has="'otp04040010'"
                            >调 整</el-button
                        >
                        <el-button
                            v-has="'otp04040023'"
                            type="primary"
                            v-show="arriveList.length"
                            @click="batchArrive(false)"
                            >批量抵达</el-button
                        >
                    </div>
                </div>
                <template class="table-head">
                    <el-table
                        :data="tableDataLists"
                        border
                        height="100"
                        row-key="senderDetailAddr"
                        label="Drag"
                        ref="dragTable"
                    >
                        <el-table-column
                            type="index"
                            label="序号"
                            width="80"
                            header-align="center"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            :prop="item.prop"
                            :label="item.label"
                            v-for="(item, index) in tableDataItems"
                            :key="index"
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width="100"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span
                                    v-has="'otp04040008'"
                                    v-if="
                                    !scope.row.expressNo &&
                                    ((isTableDataLists && scope.row.editing === 'Astern' && isBtnShow) ||
                                    (
                                        scope.row.editing === 'Astern' &&
                                        scope.row.arriFlag === 'Y'
                                    ) ||
                                    (
                                        !isBtnShow && scope.row.orderDistinctionFlag !== 'CP' &&
                                        !scope.row.actualArriveDate &&
                                        scope.row.inOutType !== 'IN' &&
                                        !(scope.row.inOutType === 'YS' && scope.row.taskStatus === 30)
                                    ))
                                    "
                                    @click="
                                        handleAstern(scope.$index, scope.row)
                                    "
                                    class="table-btn"
                                    >到车</span
                                >
                                <span
                                    v-has="'otp04040009'"
                                    v-else-if="
                                    !scope.row.expressNo &&
                                    ((isTableDataLists && scope.row.editing === 'AsternCell' && isBtnShow) ||
                                    (
                                        scope.row.editing === 'AsternCell' &&
                                        scope.row.arriFlag === 'Y'
                                    ) ||
                                    (
                                        !isBtnShow && scope.row.orderDistinctionFlag !== 'CP' &&
                                        scope.row.actualArriveDate &&
                                        scope.row.inOutType !== 'IN' &&
                                        !(scope.row.inOutType === 'YS' && scope.row.taskStatus === 30)
                                    ))
                                    "
                                    class="table-btn"
                                    @click="
                                        handleAsternCell(
                                            scope.$index,
                                            scope.row
                                        )
                                    "
                                    >取消到车</span
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template class="table-food">
                    <el-table
                        :data="paginationTableData[currentPage - 1]"
                        border
                        height="270"
                        row-key="receiverDetailAddr"
                        label="Drag"
                        :row-class-name="tableRowClassName"
                        @selection-change="handleSelectionChange"
                        ref="dragTableTitle"
                    >
                        <el-table-column
                            type="selection"
                            width="40"
                        ></el-table-column>
                        <el-table-column
                            type="index"
                            label="序号"
                            width="80"
                            header-align="center"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            :sortable="item.sort"
                            :prop="item.prop"
                            :label="item.label"
                            v-for="(item, index) in tableListsDataItems"
                            :key="index"
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width="100"
                            align="center"
                            v-if="isOperationLits"
                        >
                            <template slot-scope="scope">
                                <span
                                    v-if="
                                        +scope.row.taskStatus ===
                                        TRANSPORT_STATUS.ON_THE_WAY && !scope.row.expressNo
                                    "
                                    @click="
                                        handleDisburdenArrive(
                                            currentPage - 1,
                                            scope.$index,
                                            scope.row
                                        )
                                    "
                                    class="table-btn"
                                >
                                    <span v-has="'otp04040007'">抵达</span>
                                </span>
                                <span
                                    v-if="
                                        +scope.row.taskStatus ===
                                        TRANSPORT_STATUS.ARRIVE && !scope.row.expressNo
                                    "
                                    class="table-btn"
                                    @click="
                                        handleDisburdenArriveCell(
                                            currentPage - 1,
                                            scope.$index,
                                            scope.row
                                        )
                                    "
                                >
                                    <span v-has="'otp04040001'">取消抵达</span>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        class="table-pagination"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="tableLitsDatas.length"
                    ></el-pagination>
                </template>
            </el-card>
            <Main
                :visible.sync="visible"
                :tableData="tableData"
                :items="tabItems"
                :title="title"
                @handleClose="handleClose"
            ></Main>
            <astern-dialog
                v-if="visiable"
                :visiable.sync="visiable"
                :label-position="labelPosition"
                @handleClose="handListsleClose"
                @addOk="addOk"
                :dataVisiableLists="dataAddObj"
            ></astern-dialog>
            <detail-dialog
                ref="detailDialog"
                v-if="isDetailShow"
                :isDetailShow.sync="isDetailShow"
                :carrierName="carrierName"
                :label-position="labelPosition"
                :dispatchNo="$route.query.dispatchNo"
                @isDetailShowClose="isDetailShowClose"
                @detailShowOk="detailShowOk"
            ></detail-dialog>
        </div>
        <reserve
            ref="reserve"
            :appointmentData="appointmentData"
            :showTimePick="appointmentParams.businessMode === 'B2B'"
            @closeDialog="closeReserve"
        ></reserve>

        <!-- 电子围栏校验提示和备注 -->
            <dispatch-handle-reason
                v-if="isShowHandleReasonDialog"
                ref="dispatchHandleReason"
                :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
                :handleType="handleType"
                :dispatchNo="$route.query.dispatchNo"
                :componentsData="componentsData"
                :needTooltipData="needTooltipData"
                @handleSuccess="handleSuccess"
                @closeFenceDialog="closeFenceDialog"
            ></dispatch-handle-reason>
        <!-- 电子围栏校验提示和备注 -->
    </Paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import Paper from '@/components/core/paper/Paper';
import speed from '../../../components/speed/speed';
import InfoShow from '../../../components/speed/OneInfoShow';
import asternDialog from '../../../components/dialog/asternDialog';
import detailDialog from '../../../components/dialog/detailDialog';
import Main from '../../../components/dispatchPopup/dispatchList/Main';
import DetailTable from './DetailTable';
import data from './data.js';
import {
    getDispatchLists, getSearchdetails, getOperationLog, getStepLists, getArriveLists,
    getDispathOrderRegister, getCancelarrivesite, getoptimizationLists, appointment, allArrive,
    getArriveCellLists, updatehandlearrivedcust
} from '../../../api/dispatchOrderDetail';
import { checkSiteAddressLclOperate } from '../../../api/dispatchOrder';
import reserve from '../../../components/reserve';
import { searchTaskOrderDetails } from '../../../api/taskCenter';
import { dictWithUrl } from '@/components/lots/api.js';
import dayjs from 'dayjs';
import DispatchHandleReason from '../dispatchOrderLists/dispatchHandleReason/Index';

const payMethodIndex = new Map();
payMethodIndex.set('0', '网银转账').set('1', '油卡支付');

export default {
    name: 'dispatchOrderDetail',
    components: { Paper, speed, Main, asternDialog, detailDialog, DetailTable, InfoShow, reserve, DispatchHandleReason },
    data () {
        return {
            appointmentData: {},
            appointmentParams: {},
            resDispatchStatus: 0,
            isDetailShow: false,
            apiAwait: true,
            labelPosition: 'right',
            dataAddObj: {},
            process: {},
            infoData: [],
            feeInfoData: [],
            data: data,
            totalMileage: '',
            loadSubsidyMileage: '',
            unloadSubsidyMileage: '',
            subsidyMileage: '',
            visiable: false,
            isOperationLits: true,
            isBtnShow: false,
            isTableDataLists: false,
            isHandleTableLists: false,
            isAsternCell: true,
            tableDatas: [],
            tableDataItems: [],
            tableListsDataItems: [],
            title: '操作日志',
            tableData: [],
            originDispatchStatus: '',
            tableDataLists: [{ editing: 'Astern' }],
            tableLitsDatas: [{ editing: 'arrive' }],
            tabItems: [],
            visible: false,
            isOperation: false,
            collapseActive: [],
            carrierName: '',
            vehicleCardNumber: '',
            driverName: '',
            driverContactWayNum: '',
            isShipment: false,
            dispatchOrderDetailTime: '',
            selectedRowsData: [],
            paginationTableData: [],
            pageSize: 30,
            currentPage: 1,
            arriveList: [],
            TRANSPORT_STATUS: {
                ON_THE_WAY: 40, // 在途
                ARRIVE: 50 // 抵达
            },
            wtTypeFlag: false,
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'arrival', // 操作类型：运抵
            componentsData: null,
            handleDisburdenArriveParams: {}, // 抵达参数
            needTooltipData: []
        };
    },
    mounted () {
        this.load();
        document.querySelector('.departure .numbers').addEventListener('dblclick', (e) => {
            e.stopPropagation();
            this.copyText();
        });
    },
    methods: {
        GetDateT (d) {
            var s;
            s = d.getYear() + 1900 + '-';
            s = s + (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-';
            s += d.getDate() < 10 ? '0' + d.getDate() : d.getDate() + '';
            return (s);
        },
        // 预约返回值
        closeReserve (val, type) {
            if (type === 'sure') {
                const { mFormData } = val;
                if (mFormData.appointTime && !mFormData.appointType) {
                    return this.$message.warning('请选择预约类型');
                }
                if (mFormData.appointType && !mFormData.appointTime) {
                    return this.$message.warning('请选择预约时间');
                }
                appointment({ ...mFormData, ...this.appointmentParams, taskNo: val.taskNo }).then(res => {
                    if (res.code === '0') {
                        this.$message.success('预约成功');
                        this.$refs.reserve.visible = false;
                    }
                });
            } else if (type === 'negative') {
                this.$refs.reserve.formData = { appointTime: this.GetDateT(new Date()) + ' 23:59:59' };
            } else {
                this.$refs.reserve.visible = false;
            }
        },
        // 预约按钮
        reserveClick (data) {
            this.$refs.reserve.formData = { appointTime: this.GetDateT(new Date()) + ' 23:59:59' };
            this.$refs.reserve.showDialog();
            searchTaskOrderDetails({ taskNo: data.taskNo }).then(res => {
                if (res.code === '0') {
                    const d = res.data;
                    this.appointmentParams.orderCode = d.orderNo;
                    this.appointmentParams.businessMode = d.businessMode;
                    this.$refs.reserve.dialogs.dialogForm.inputList.map(
                        item => {
                            if (['appointTime', 'appointReason', 'appointType', 'secendAppointReason'].includes(item.value)) {
                                item.readOnly = true;
                            }
                            if (d.businessMode === 'B2C') {
                                if (['appointTime', 'appointType'].includes(item.value)) {
                                    item.readOnly = false;
                                }
                            } else {
                                if (['appointReason', 'appointType', 'secendAppointReason'].includes(item.value)) {
                                    item.readOnly = false;
                                }
                            }
                            if (item.value === 'appointType') {
                                if (d.orderInfo.orderStatus >= 350) {
                                    item.options = [{ 'label': '配送预约', 'value': 'DELEIVERY_APPOINTMENT' }];
                                } else {
                                    item.options = [{ 'label': '仓内预约', 'value': 'WH_APPOINTMENT' }];
                                }
                            }
                        }
                    );
                    const obj = {};
                    obj.taskNo = d.taskNo;
                    obj.customerOrderNo = d.customerOrderNo;
                    const addr = `${d.taskAddress.finalProvinceName}${d.taskAddress.finalCityName}${d.taskAddress.finalDistrictName}${d.taskAddress.finalTownName}${d.taskAddress.finalDetailAddr}`;
                    obj.receiveMessage = `${d.taskAddress.finalName}/${d.taskAddress.finalMobile}/${addr}`;
                    obj.expectTime = d.expectArriveEndTime
                        ? `${d.expectArriveStartTime}~${d.expectArriveEndTime}`
                        : d.expectArriveStartTime;
                    this.appointmentData = obj;
                }
            });
        },
        isDetailShowClose () { this.isDetailShow = false; },
        detailShowOk (code) {
            if (code.code === '0') {
                this.isDetailShow = false;
                this.$nextTick(() => {
                    this.load();
                });
            }
        },
        async load () {
            this.loadSpteLists();
            await this.loadOptimizationLists();
            await this.loadDetails();
            this.loadOpionsList();
        },
        loadOpionsList () {
            this.isShipment = false;
            this.isOperation = false;
            let ysTypeCount = 0;
            this.wtTypeFlag = false;
            getSearchdetails(this.$route.query.dispatchNo).then(res => {
                if (res) {
                    this.tableDatas = res.data.list || [];
                    this.tableDatas.forEach(item => {
                        if (['YS', 'IN'].includes(item.inOutType)) ++ysTypeCount;
                        if (item.scanNum > 0 && +item.taskStatus < 30) {
                            this.wtTypeFlag = true;
                        }
                    });
                    this.isTableDataLists = !!ysTypeCount;
                    this.apiAwait = false;
                }
            });
        },
        async loadOptimizationLists () {
            await getoptimizationLists(this.$route.query.dispatchNo).then(res => {
                this.tableDataLists = [];
                this.tableLitsDatas = [];
                this.totalMileage = res.data.totalMileage;
                this.loadSubsidyMileage = res.data.loadSubsidyMileage;
                this.unloadSubsidyMileage = res.data.unloadSubsidyMileage;
                this.subsidyMileage = res.data.subsidyMileage;
                const setTaskStatus = new Map();
                const arrivalModeSetMap = new Map();
                const arriveTypeSetMap = new Map();
                const arriveTypeTaskStatusMap = new Map();
                setTaskStatus.set(10, 'Astern').set(20, 'AsternCell');
                arrivalModeSetMap.set('', '').set('01', '手动到车').set('02', '直通宝到车').set('04', '直通宝到车').set('05', '直通宝到车').set('06', '围栏到车').set('07', 'CSP扫码到车');
                arriveTypeTaskStatusMap.set(40, 'arrive').set(50, 'arriveCell');
                arriveTypeSetMap
                    .set('', '')
                    .set('01', '手动抵达')
                    .set('02', '直通宝抵达')
                    .set('03', '自动抵达')
                    .set('04', '签收触发抵达')
                    .set('05', '直通宝APP抵达')
                    .set('06', '直通宝微信抵达')
                    .set('07', '打点触发抵达')
                    .set('08', '蓝桥抵达')
                    .set('09', '车满满抵达')
                    .set('10', '围栏抵达')
                    .set('11', '直通宝审批抵达')
                    .set('12', '直通宝APP抵达')
                    .set('13', '直通宝微信抵达');
                if (res && res.code === '0') {
                    let isOperationLitsCount = 0;
                    this.tableDataLists = res.data.loadList.map(item => {
                        item.editing = setTaskStatus.get(item.taskStatus);
                        item.arriveTypeText = arrivalModeSetMap.get(item.arriveType);
                        return item;
                    });
                    this.tableLitsDatas = res.data.unloadList.map(item => {
                        item.arrivalWayText = arriveTypeSetMap.get(item.arrivalWay);
                        item.editing = arriveTypeTaskStatusMap.get(item.taskStatus);
                        if (+item.taskStatus === this.TRANSPORT_STATUS.ON_THE_WAY || +item.taskStatus === this.TRANSPORT_STATUS.ARRIVE) ++isOperationLitsCount;
                        return item;
                    });
                    this.isOperationLits = isOperationLitsCount;
                }
            }).catch(() => { });
            this.isArriveBtnShow();
        },
        isArriveBtnShow () {
            // 城配单，卡控专业公司全为零担。基地单，不卡控
            this.isBtnShow = this.tableDatas.every(item => {
                return item.professionalCompany === '3' && item.orderDistinctionFlag === 'CP';
            });
        },
        // 关闭围栏备注弹窗
        closeFenceDialog () {
            this.isShowHandleReasonDialog = false;
            this.load();
        },
        // 围栏校验备注回调函数
        handleSuccess ({ isFenceRemarked, data }) {
            if (Array.isArray(data)) {
                this.batchArrive(isFenceRemarked);
            } else {
                const { currentPage, $index, row } = this.handleDisburdenArriveParams;
                this.handleDisburdenArrive(currentPage, $index, row, isFenceRemarked);
            }
        },
        // 电子围栏校验，接口返回true则需要备注人工操作原因
        validateFence (data) {
            const siteAddressList = Array.isArray(data) ? data.map(v => v.receiverDetailAddr) : [data.receiverDetailAddr];
            const params = {
                type: 'arrival',
                dispatchNo: this.$route.query.dispatchNo,
                siteAddressList
            };
            return checkSiteAddressLclOperate(params).then(res => {
                if (res && +res.code === 0) {
                    if (Array.isArray(res.data) && res.data.length) {
                        this.needTooltipData = res.data;
                        return true;
                    } else {
                        return false;
                    }
                }
            }).catch(() => {
                return false;
            });
        },
        /**
         * description 站点运抵确认 运抵确认前进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async handleDisburdenArrive (currentPage, $index, row, isFenceRemarked = false) {
            // 保存参数，供回调时继续运抵操作
            this.handleDisburdenArriveParams = { currentPage, $index, row };
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.validateFence(row);
                if (isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.handleType = 'arrival';
                    this.componentsData = row.receiverDetailAddr;
                    return;
                }
            }
            // 继续运抵操作
            var time = new Date();
            var postDepartureTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate() + ' ' + time.getHours() + ':' + time.getMinutes() + ':' + time.getSeconds();
            var timeDifference = String(parseInt(new Date(this.dispatchOrderDetailTime) - new Date(postDepartureTime)) / 1000 / 60).replace(/-/g, '');
            if (timeDifference < 30) {
                this.$message.warning('发车后30分钟内，不支持手工抵达');
                return this.load();
            }
            this.paginationTableData[currentPage][$index].editing = 'arriveCell';
            const params = { dispatchNo: this.process.orderNo, receiverDetailAddr: row.receiverDetailAddr };
            getArriveLists(params).then(res => {
                if (res.code === '0') {
                    this.$message.success('抵达成功');
                    this.load();
                }
            });
        },
        handleDisburdenArriveCell (currentPage, $index, row) {
            this.paginationTableData[currentPage][$index].editing = 'arrive';
            const params = { dispatchNo: this.process.orderNo, receiverDetailAddr: row.receiverDetailAddr };
            getArriveCellLists(params).then(res => {
                if (res.code === '0') {
                    this.$message.success('取消抵达成功');
                    this.load();
                }
            });
        },

        handleAstern ($index, row) {
            // this.tableDataLists[$index].editing = 'AsternCell';
            this.dispatchNo = this.process.orderNo;
            this.senderDetailAddrName = row.senderDetailAddr;
            this.visiable = true;
            const dataObj = { vehicleCard: this.vehicleCardNumber, driver: this.driverName, driverContactWay: this.driverContactWayNum, dispatchNo: this.dispatchNo, siteAddress: row.senderDetailAddr, index: $index };
            this.dataAddObj = dataObj;
        },
        handListsleClose () {
            this.visiable = false;
            this.load();
        },
        addOk (formName) {
            const senderDetailAddrName = this.senderDetailAddrName;
            const dispatchNo = this.dispatchNo;
            formName.data['dispatchNo'] = dispatchNo;
            formName.data['senderDetailAddr'] = senderDetailAddrName;
            if (formName.state === true) {
                getDispathOrderRegister(formName.data, this.dispatchNo, this.senderDetailAddrName).then(async res => {
                    if (res && res.code === '0') {
                        this.$message.success('保存成功');
                        await this.load();
                        this.tableDataLists[formName.data[index]].editing = 'AsternCell';
                    }
                }).catch(() => {
                    this.load();
                });
            } else {
                return false;
            }
        },
        handleAsternCell ($index, row) {
            const params = { dispatchNo: this.process.orderNo, senderDetailAddr: row.senderDetailAddr };
            getCancelarrivesite(params).then(async res => {
                if (res.code === '0') {
                    this.$message.success('取消到车成功');
                    await this.load();
                    this.tableDataLists[$index].editing = 'Astern';
                } else {
                    await this.load();
                    this.tableDataLists[$index].editing = 'Astern';
                }
            });
        },
        handleTableLists () {
            this.isDetailShow = true;
        },
        loadSpteLists () {
            getStepLists(this.$route.query.dispatchNo).then(res => {
                if (res && res.code === '0') {
                    res.data.list.forEach((item, index) => {
                        this.process.step[index].id = String(item.isShow);
                        this.process.step[index].carName = item.dispatchStatusName;
                        this.process.step[index].carTimes = item.createTime;
                    });
                }
            });
        },
        operation () {
            var params = { dispatchNo: this.$route.query.dispatchNo, type: '10' };
            getOperationLog(params).then(res => {
                if (res && res.code === '0') {
                    this.tableData = res.data.map((item, index) => {
                        item.type = item.dispatchStatusName;
                        return item;
                    });
                }
            });
            this.visible = true;
        },
        openMapClick () {
            this.$router.push({
                name: 'trafficTrajectory',
                params: { name: '/distribute/traffic-trajectory', dispatchNo: this.$route.query.dispatchNo }
            });
        },
        handleClose () { this.visible = false; },
        async loadDetails () {
            const dict = await dictWithUrl('DISPATCH_STATUS,YES_OR_NO');
            const dictData = dict.data;
            const stateMap = new Map();
            stateMap.set('00', '公路运输').set('10', '海路运输').set('20', '铁路运输').set('30', '航空运输').set('40', '内河运输');
            await getDispatchLists(this.$route.query.dispatchNo).then(res => {
                if (res && res.code === '0') {
                    this.dispatchOrderDetailTime = res.data.dispatchTime;
                    if (res.data.procurementChannel === '190' && res.data.dispatchStatus <= 30) {
                        this.isHandleTableLists = true;
                    } else { this.isHandleTableLists = false; }
                    this.vehicleCardNumber = res.data.vehicleCard;
                    this.driverName = res.data.driver;
                    this.carrierName = res.data.carrierName;
                    this.driverContactWayNum = res.data.driverContactWay;
                    this.infoData[0].subItems[0].value = this.vehicleCardNumber;
                    this.infoData[0].subItems[1].value = `${this.driverName || ''} / ${this.driverContactWayNum || ''}`;
                    this.infoData[0].subItems[2].value = res.data.carrierName;
                    this.infoData[1].subItems[0].value = res.data.siteName;
                    this.infoData[1].subItems[1].value = dictData.YES_OR_NO[res.data.conveniently] || res.data.conveniently;
                    this.infoData[1].subItems[2].value = res.data.remark;
                    this.feeInfoData[0].subItems[0].value = res.data.transportationCost ? res.data.transportationCost + '元' : '';
                    this.feeInfoData[0].subItems[1].value = res.data.prepaidAmount ? res.data.prepaidAmount + '元' : '';
                    this.feeInfoData[0].subItems[2].value = res.data.payMethod ? payMethodIndex.get(res.data.payMethod) : '';
                    this.feeInfoData[0].subItems[3].value = res.data.infoFee ? res.data.infoFee + '元' : '';
                    this.feeInfoData[0].subItems[4].value = res.data.taxRate ? res.data.taxRate + '%' : '';
                    this.feeInfoData[0].subItems[5].value = res.data.oilcardPayAmount ? res.data.oilcardPayAmount + '元' : '';
                    this.process.orderNo = res.data.dispatchNo;
                    this.process.title = this.originDispatchStatus = res.data.dispatchStatus;
                    this.process.title = dictData.DISPATCH_STATUS[this.process.title] || this.process.title;
                }
            });
        },
        copyText () {
            var clickContent = document.querySelector('.departure .numbers').innerText;
            var input = document.createElement('input');
            document.body.appendChild(input);
            input.setAttribute('value', clickContent);
            input.setAttribute('readonly', 'readonly');
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        getHandLoadingsSave () { this.load(); },
        handleSelectionChange (data) {
            this.selectedRowsData = data;
            this.arriveList = data.filter(item => {
                return item.taskStatus === this.TRANSPORT_STATUS.ON_THE_WAY && !item.expressNo;
            });
        },
        tableRowClassName ({ row }) {
            if (this.selectedRowsData.includes(row)) {
                return 'highlight-row';
            }
        },
        /**
         * description 批量站点运抵确认 运抵确认前进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async batchArrive (isFenceRemarked = false) {
            var time = new Date();
            var postDepartureTime = dayjs(time).format('YYYY-MM-DD HH:mm:ss');
            var timeDifference = String(parseInt(new Date(this.dispatchOrderDetailTime) - new Date(postDepartureTime)) / 1000 / 60).replace(/-/g, '');
            if (timeDifference < 30) {
                this.$message.warning('发车后30分钟内，不支持手工抵达');
                return this.load();
            }
            let arriveListData = [];
            arriveListData = this.selectedRowsData.filter(item => {
                return item.taskStatus === this.TRANSPORT_STATUS.ON_THE_WAY;
            });
            if (arriveListData.length < 1) {
                return this.$message.warning('没有符合条件的单据可操作性！');
            }
            // 电子围栏校验
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.validateFence(arriveListData);
                if (isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.handleType = 'arrival';
                    this.componentsData = arriveListData;
                    return;
                }
            }
            const receiverDetailAddrList = arriveListData.map(v => v.receiverDetailAddr);
            updatehandlearrivedcust({ dispatchNo: this.process.orderNo, receiverDetailAddrList })
                .then(res => {
                    if (res && +res.code === 0) {
                        if (Array.isArray(res.data) && res.data.length) {
                            const message = res.data.join('<br/>');
                            this.$message({
                                type: 'error',
                                message: message,
                                dangerouslyUseHTMLString: true
                            });
                        } else {
                            this.$message.success('抵达成功');
                        }
                        this.load();
                    }
                })
                .catch(() => {});
        },
        handleSizeChange (val) {
            this.pageSize = val;
        },
        handleCurrentChange (val) {
            this.currentPage = val;
        },
        dataInit () {
            const tableData = [];
            let arr = [];
            this.tableLitsDatas.map((item, index) => {
                arr.push(item);
                if ((index + 1) % this.pageSize === 0 || index === this.tableLitsDatas.length - 1) {
                    tableData.push(arr);
                    arr = [];
                }
            });
            this.paginationTableData = tableData;
        }
    },
    activated () { this.load(); },
    created () {
        this.process = data.process;
        this.infoData = data.infoData;
        this.feeInfoData = data.feeInfoData;
        this.tableDataItems = data.tableDataItems;
        this.tableListsDataItems = data.tableListsDataItems;
        this.tabItems = data.tabItems;
        this.dataInit();
    },
    watch: {
        tableLitsDatas () {
            this.dataInit();
        },
        tableDatas () {
            this.isArriveBtnShow();
        },
        pageSize () {
            this.dataInit();
        }
    }
};
</script>
<style lang='less'>
@import '../styles/common.less';
@import './dispatchOrderDetail.less';
.example {
    .el-table__body tr.highlight-row {
        background: #e6f8f9;
    }
    .table-pagination {
        margin: 10px 0px;
        float: right;
        padding: 0;
        .btn-prev,
        .btn-next,
        .el-pager li {
            background-color: #ffffff !important;
            border: 1px solid #cccccc;
            border-radius: 4px !important;
            padding: 0;
            min-width: 30px;
            margin-right: 4px;
        }
        .el-pager li.active + li {
            border-left: 1px solid #cccccc;
        }
        .el-pager li:not(.disabled).active {
            background-color: #00bcbf !important;
            border: 1px solid #00bcbf;
            color: #ffffff;
        }
    }
}
</style>
